import React, {
  PropTypes as T,
  Component,
} from 'react';
import radium from 'radium';
import { connect } from 'react-redux';
import { Link as link } from 'react-router';
import { bindActionCreators } from 'redux';
import * as SelectionActions from '../../actions/Selection.js';
import SelectionPreviewer from './SelectionPreviewer.js';
import Helpers from '../../helpers';

const Link = radium(link);

const styles = {
  contentWrap: {
    padding: '0 24px',
    '@media (max-width: 800px)': {
      marginBottom: 44,
    },
  },
  title: {
    color: '#a39671',
    padding: '24px 0 12px 0',
    fontSize: 18,
    fontWeight: 300,
    margin: 0,
    letterSpacing: 5,
  },
  list: {
    margin: '0 -18px',
    padding: 0,
    display: 'flex',
    width: 'calc(100% + 36px)',
    flexWrap: 'wrap',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  list_TV: {
    margin: '0px auto',
    display: 'flex',
    width: '80%',
    flexWrap: 'wrap',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  item: {
    cursor: 'pointer',
    textDecoration: 'none',
    width: 78,
    height: 28,
    margin: '12px 18px',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    padding: 14,
    fontSize: 18,
    color: '#4a4a4a',
    backgroundColor: '#fff',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center, center',
    opacity: 0.5,
    ':hover': {
      opacity: 1,
    }
  },
  item_TV: {
    cursor: 'pointer',
    textDecoration: 'none',
    width: 78,
    height: 28,
    margin: '0 5%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 14,
    fontSize: 18,
    color: '#4a4a4a',
    backgroundColor: '#fff',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center, center',
    opacity: 0.5,
    ':hover': {
      opacity: 1,
    },
  },
  selected: {
    opacity: 1,
  },
  bottom: {
    position: 'fixed',
    bottom: 60,
    height: 44,
    color: '#fff',
    backgroundColor: '#9b9b9b',
    width: 'calc(100% - 250px)',
    padding: '0 24px',
    '@media (max-width: 800px)': {
      position: 'fixed',
      width: '100%',
    },
  },
  bottom_TV: {
    position: 'fixed',
    bottom: 60,
    height: 44,
    color: '#fff',
    backgroundColor: '#9b9b9b',
    width: '100%',
    padding: '0 24px',
  },
  link: {
    fontSize: 18,
    fontWeight: 100,
    height: 44,
    lineHeight: '44px',
    padding: 0,
    display: 'inline-block',
    color: '#fff',
    textDecoration: 'none',
  },
  spacer: {
    flex: 1,
  },
  colorList: {
    margin: '0 -21px',
    padding: 0,
    display: 'flex',
    width: 'calc(100% + 42px)',
    flexWrap: 'wrap',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  colorList_TV: {
    margin: '0px auto',
    display: 'flex',
    width: '80%',
    flexWrap: 'wrap',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  colorItem: {
    cursor: 'pointer',
    textDecoration: 'none',
    width: 120,
    height: 120,
    borderRadius: 60,
    margin: '12px 21px',
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'center',
    padding: 14,
    fontSize: 18,
    color: '#4a4a4a',
    backgroundColor: '#fff',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center, center',
    border: '6px solid transparent',
    ':hover': {
      border: '6px solid #fbbb0c',
    },
  },
  colorSelected: {
    border: '6px solid #fbbb0c',
  },
};

class SelectionColorList extends Component {
  constructor(props) {
    super(props);

    if (!props.location.query
      || isNaN(props.location.query.type)
      || isNaN(props.location.query.character)) {
      props.backToTypeSelection();
    } else {
      this.state = {
        selectedColorId: null,
        selectedFirmId: null,
        typeId: parseInt(props.location.query.type, 10),
        characterId: parseInt(props.location.query.character, 10),
      };
    }
  }

  componentWillMount() {
    const {
      fetchSelectionDetail,
    } = this.props;

    const {
      typeId,
    } = this.state;

    fetchSelectionDetail(typeId);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.firms !== this.props.firms && nextProps.firms.length) {
      this.setState({
        selectedFirmId: nextProps.firms[0].id,
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.selectedFirmId !== this.state.selectedFirmId) {
      this.autoSelectFirstColor();
    }
  }

  autoSelectFirstColor() {
    const firm = this.props.firms.find(f => f.id === this.state.selectedFirmId);

    if (!firm) return;

    this.setState({
      selectedColorId: firm.colors.length ? firm.colors[0].id : null,
    });
  }

  render() {
    const {
      firms,
    } = this.props;

    const {
      selectedColorId,
      selectedFirmId,
      typeId,
      characterId,
    } = this.state;

    const selectedFirm = firms.find(f => f.id === selectedFirmId);

    var item = styles.item;
    var bottom = styles.bottom;
    var list_style = styles.list;
    var colorList = styles.colorList;

    if (Helpers.Session.isViaTV()) {
      item = styles.item_TV;
      bottom = styles.bottom_TV;
      list_style = styles.list_TV;
      colorList = styles.colorList_TV;
    }

    return (
      <div style={styles.wrap}>
        <div style={styles.contentWrap}>
          <SelectionPreviewer
            firmId={selectedFirmId}
            colorId={selectedColorId}
            typeId={typeId}
            characterId={characterId} />
          <h1 style={styles.title}>請選擇顏色：</h1>
          <div style={list_style}>
            {firms.map(firm => (
              <div
                onClick={() => this.setState({ selectedFirmId: firm.id })}
                style={[
                  item,
                  selectedFirmId === firm.id && styles.selected,
                  {
                    backgroundImage: `url(${firm.url})`,
                  },
                ]}
                key={firm.id}></div>
            ))}
          </div>
          <div style={colorList}>
            {selectedFirm ? (
              selectedFirm.colors.map(color => (
                <div style={styles.colorWrapper} key={`color-${color.id}`}>
                  <div
                    onClick={() => this.setState({ selectedColorId: color.id })}
                    style={[
                      styles.colorItem,
                      selectedColorId === color.id && styles.colorSelected,
                      {
                        backgroundImage: `url(${color.cover})`,
                      },
                    ]} key={`color-cover-${color.id}`}></div>
                </div>
              ))
            ) : null}
          </div>
        </div>
        <div style={bottom}>
          <Link
            to={`/selections/characters?type=${typeId}`}
            style={styles.link}>上一步</Link>
        </div>
      </div>
    );
  }
}

SelectionColorList.propTypes = {
  firms: T.array,
  fetchSelectionDetail: T.func,
  location: T.shape({
    query: T.shape({
      type: T.string,
      character: T.string,
    }),
  }),
  backToTypeSelection: T.func,
};

export default connect(
  state => ({
    firms: state.Selection.firms,
  }),
  dispatch => bindActionCreators(SelectionActions, dispatch),
)(radium(SelectionColorList));



// WEBPACK FOOTER //
// ./containers/Selections/SelectionColorList.js